import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=ba5980d6"
import script from "./employees.vue?vue&type=script&lang=js"
export * from "./employees.vue?vue&type=script&lang=js"
import style0 from "./employees.vue?vue&type=style&index=0&id=ba5980d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports